export const GET_MY_ORDERS = "GET_MY_ORDERS";
export const CANCEL_ORDER = "CANCEL_ORDER";
